import { NavLink } from 'react-router-dom';
import { useMeContext } from '../api/me-provider.js';

/**
 * APPROVED 22 September 2026.
 *
 * This began as an inference — the mockups were phone-width and tokens.css sets
 * --tap-min: 44px, which points at thumbs — and was marked provisional because
 * no mockup had shown it. The booking canvas settled it, and the people canvas
 * uses the same bar.
 *
 * Lessons is a TAB rather than something reached through a person. A parent reads
 * every person's lessons in the lessons view, the account holder's own among
 * them. That is what keeps a lesson one push away instead of three.
 *
 * Ruled 1 November: Messages is gone from every bar, and parents have Tools in
 * its place. An MPC coach has no Tools.
 */

const ITEMS = [
  { to: '/', label: 'Home', end: true },
  { to: '/booking', label: 'Book', end: false },
  { to: '/lessons', label: 'Lessons', end: false },
  { to: '/tools', label: 'Tools', end: false },
  { to: '/account', label: 'Account', end: false },
] as const;

export function AppNav() {
  const { state } = useMeContext();
  const coach = state.status === 'ready' && state.me.is_mpc_coach;
  return (
    <nav className="app-nav" aria-label="Primary">
      {ITEMS.filter((item) => !(coach && item.to === '/tools')).map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
